import { AUTH_EVENTS } from './authEvents';
import { LANDING_EVENTS } from './landingEvents';
import { UPLOAD_EVENTS } from './uploadEvents';
import { RESULT_EVENTS } from './resultEvents';
import { ANALYSIS_EVENTS } from './analysisEvents';
import { HISTORY_EVENTS } from './historyEvents';
import { ACCOUNT_BILLING_EVENTS } from './accountBillingEvents';
import { CONTENT_EVENTS, BLOG_SEARCH_ANALYTICS } from './contentEvents';
import { NAVIGATION_EVENTS } from './navigationEvents';
import { EXTENSION_EVENTS } from './extensionEvents';

export const ANALYTICS_EVENTS = Object.freeze({
  ...AUTH_EVENTS,
  ...LANDING_EVENTS,
  ...UPLOAD_EVENTS,
  ...RESULT_EVENTS,
  ...ANALYSIS_EVENTS,
  ...HISTORY_EVENTS,
  ...ACCOUNT_BILLING_EVENTS,
  ...CONTENT_EVENTS,
  ...NAVIGATION_EVENTS,
  ...EXTENSION_EVENTS
});

export const EVENT_TYPES = Object.freeze(
  Object.fromEntries(
    Object.entries(ANALYTICS_EVENTS).map(([key, event]) => [key, event.name])
  )
);

export {
  AUTH_EVENTS,
  LANDING_EVENTS,
  UPLOAD_EVENTS,
  RESULT_EVENTS,
  ANALYSIS_EVENTS,
  HISTORY_EVENTS,
  ACCOUNT_BILLING_EVENTS,
  CONTENT_EVENTS,
  NAVIGATION_EVENTS,
  EXTENSION_EVENTS,
  BLOG_SEARCH_ANALYTICS
};
